/**
 * The content revision MCP-style CAS writes compare against — the web twin of
 * `record_rev` in src-tauri/src/sync/records.rs: the first 16 hex chars of
 * sha256 over canonical JSON (object keys sorted at every depth).
 */

/** JSON with object keys sorted at every depth, so equal content hashes equal. */
export function canonicalJson(value) {
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(',')}]`;
  if (value && typeof value === 'object') {
    const keys = Object.keys(value)
      .filter((k) => value[k] !== undefined)
      .sort();
    return `{${keys.map((k) => `${JSON.stringify(k)}:${canonicalJson(value[k])}`).join(',')}}`;
  }
  return value === undefined ? 'null' : JSON.stringify(value);
}

export function sameContent(a, b) {
  return canonicalJson(a) === canonicalJson(b);
}

export async function recordRev(data) {
  const bytes = new TextEncoder().encode(canonicalJson(data));
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 16);
}
